import { FC } from "react";
import "./App.less";

import { BrowserRouter as Router } from "react-router-dom";
import { UserStateProvider } from "./common/UserContext";
import { AppNavProvider } from "./common/AppNavContext";
import { AppRoutes } from "./AppRoutes";
import { DemoMakerMount } from "./components/demo/maker/DemoMakerMount";

/**
 *
 * TODO: OPTIMIZE ROUTE RENDERING
 */
const App: FC = () => (
    <Router>
        <UserStateProvider>
            <AppNavProvider>
                <AppRoutes />
                <DemoMakerMount />
            </AppNavProvider>
        </UserStateProvider>
    </Router>
);

export default App;
